/**
 * Alinea cada bloque del mega menú con el enlace que lo abre.
 * Calcula el padding al cargar (y en resize / pointerdown) para que al abrir
 * ya esté en su sitio — sin saltar de la izquierda a la posición final.
 */
(function () {
  function alignOne(details) {
    var list = details.querySelector('.mega-menu__list--caracola');
    var summary = details.querySelector('summary');
    if (!list || !summary) return;

    // El panel puede estar display:none mientras el details está cerrado;
    // usamos el header-wrapper (mismo ancho que el mega) como referencia estable.
    var ref =
      document.querySelector('.header-wrapper') ||
      document.querySelector('.header') ||
      list.closest('.mega-menu__content');
    if (!ref) return;

    var text = summary.querySelector('span') || summary;
    var pad = Math.max(0, text.getBoundingClientRect().left - ref.getBoundingClientRect().left);
    list.style.setProperty('--mega-pad-left', pad + 'px');
  }

  function align() {
    document.querySelectorAll('header-menu details.mega-menu').forEach(alignOne);
  }

  function bind() {
    align();

    document.querySelectorAll('header-menu details.mega-menu > summary').forEach(function (summary) {
      summary.addEventListener('pointerdown', align);
      summary.addEventListener('focus', align);
    });

    document.querySelectorAll('header-menu details.mega-menu').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (details.open) align();
      });
    });

    bindHover();

    window.addEventListener('resize', align);
  }

  function bindHover() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    document.querySelectorAll('header-menu details.mega-menu').forEach(function (details) {
      var summary = details.querySelector('summary');
      var closeTimer;

      function openMenu() {
        clearTimeout(closeTimer);
        if (!details.open) details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
        align();
      }

      function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 220);
      }

      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', scheduleClose);

      if (summary) {
        summary.addEventListener('click', function (event) {
          if (event.detail === 0) return;
          event.preventDefault();
          // Con ratón el panel ya se abre al pasar por encima: el clic lleva
          // a la colección del enlace (la misma del botón del panel).
          var href = summary.getAttribute('data-href');
          if (href) {
            window.location.href = href;
            return;
          }
          openMenu();
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
